import { Storyblok } from '../../storyblok';
import { SiteActions } from './action';

export interface SiteState {
    error: Storyblok.Content.ErrorType | null;
    datasources: any;
    pageguards:
        | (Storyblok.PageGuards.PageGuard & { _loaded: boolean; _id: number })[]
        | 'loading';
}

export const defaultSiteState: SiteState = {
    error: null,
    datasources: null,
    pageguards: 'loading',
};

export const siteReducer = (
    state: SiteState = defaultSiteState,
    action: SiteActions,
): SiteState => {
    switch (action.type) {
        case 'SET_ERROR':
            return {
                ...state,
                error: action.payload,
            };

        case 'CLEAR_ERROR':
            return defaultSiteState;

        case 'ADD_DATASOURCES':
            return {
                ...state,
                datasources: action.payload,
            };
        case 'UPDATE_PAGEGUARDS':
            return {
                ...state,
                pageguards: action.payload,
            };
        default:
            return state;
    }
};
